<template>
	<div class="material-list-wrapper">
		<EmptyPage 
			v-if="materialList.length === 0" 
			:height="480" 
			:loading="loading" />
		<div v-else>
			<div class="material-list">
				<div 
					class="material-list-item" 
					v-for="(item, index) in materialList" 
					:key="index">
					<MaterialCard 
						:material="item" 
						@set-material="setMaterial" 
						:user="user" />
				</div>
			</div>
			<div 
				class="loading" 
				v-show="scrollLoading">
				<i class="el-icon-loading"></i>
			</div>
			<!-- 分页 -->
			<div class="material-list__pagination">
				<el-pagination
					background
					layout="prev, pager, next"
					:hide-on-single-page="true"
					:page-size="pageSize"
					:current-page="pageNum"
					:total="total"
					@current-change="handlePageChange">
				</el-pagination>
			</div>
		</div>
		<!-- <material-detail v-if="material" :material.sync="material" @updateMaterialList="updateMaterialList"></material-detail> -->
	</div>
</template>

<script>
import { mapState } from 'vuex';
import { getMaterialList, getUserCollectionMaterials, getUserMaterialPaid, getMateiralByAuthor, getMyMaterial } from '@/api/material';
import { openWindow } from '@/utils/utils';
import MaterialCard from './MaterialCard';
// import MaterialDetail from './MaterialDetail';
import EmptyPage from '@/components/EmptyPage';
export default {
	name: 'MaterialList',
    components: {
		MaterialCard,
		// MaterialDetail,
		EmptyPage
    },
    props: {
		// 各项标签
        tab: {
            type: Object,
            default: () => ({})
		},
		// 素材类型【1：免费素材】
		materialType: {
			type: String,
			default: '1'
		},
		// 素材归属用户
		user: {
			type: Object,
			required: false
		},
		// 是否是已收藏素材
		collected: {
			type: Boolean,
			required: false
		},
		type: {
			type: [String, Number],
			required: false
		},

		author: {
			type: Boolean,
			required: false,
			default: false
		}
	},
	inject:['backTop'],
	data() {
		return {
			loading: false,
			scrollLoading: false,
			total: 0,
			pageSize: 40,
			pageNum: 1,
			pages: 1,
			// 素材列表
			materialList: [],
			// 需要显示详情的素材
			material: null,
			tab:{}
		}
	},
    computed: {
        ...mapState('app', ['scrollStatus'])
    },
	watch: {
		tab: {
			deep: true,
            immediate:true,
			handler(newVal, oldVal) {
				console.log('newVal: ', newVal);
				// Object.assign(this.$data, this.$options.data.call(this));
				this.materialList = [];
				this.total = 0;
				this.pageSize = 40;
				// this.pageNum = sessionStorage.getItem(this.$route.path) || 1;
				this.pageNum = 1;
				this.pages = 1;
				if((this.$route.params.type || this.$route.params.subType) && !newVal.category) {
					return True
				}
				if (!this.loading){
					this.getMaterialList();
				}
			}
		},
		// scrollStatus() {
		// 	if (!this.user && !this.scrollLoading) {
		// 		this.scroll();
		// 	}
		// },
		type:{
			immediate:true,
			handler(newVal, oldVal) {
				this.materialList = [];
				this.total = 0;
				this.pageSize = 40;
				this.pageNum =  1;
				// this.pageNum = sessionStorage.getItem(this.$route.path) || 1;
				this.pages = 1;
				if (!this.loading && newVal){
					this.getMaterialList();
				}
			}
		}
		// material: {
		// 	deep: true,
		// 	handler(val) {
		// 		if (!val) {
		// 			this.pageNum = 1;
		// 			this.getMaterialList();
		// 		}
		// 	}
		// },
	},
	created() {
		// this.pageNum = sessionStorage.getItem(this.$route.path) || 1
		// this.getMaterialList();
	},
	methods: {
		/**
		 * 回填素材列表（用户可能在详情页收藏或下载，列表需同步更新）
		 */
		updateMaterialList(newMaterialInfo) {
			// 有id时更新指定素材信息
			if (newMaterialInfo.id) {
				const material = this.materialList.find(material => material.id === newMaterialInfo.id);
				Object.assign(material, newMaterialInfo);
			} else {
				// 否则批量更新
				this.materialList.forEach(material => Object.assign(material, newMaterialInfo));
			}
		},
		handlePageChange(pageNum) {
			sessionStorage.setItem(this.$route.path,pageNum)
            this.pageNum = pageNum;
            this.backTop();
            this.getMaterialList();
        },
        // 无限滚动
        scroll() {
            if (this.pageNum > 100) return;
            if (this.pageNum >= this.pages) return;
            this.scrollLoading = true;
            this.pageNum++;
            this.getMaterialList();
        },
		// 获取素材
		getMaterialList() {
			this.loading = true;
			let queryAjax,params;
			if (this.author) {
				queryAjax = getMateiralByAuthor;
				params = {
					author: (this.tab || {}).author,
					pageNum: this.pageNum,
					pageSize: this.pageSize,
				}
			} else {
				if (+this.type === 7) {
					queryAjax = getUserMaterialPaid
				} else if(+this.type === 4){
					queryAjax = this.getUserCollection
				} else if(+this.type === 9){
					queryAjax = getMyMaterial;
					params = {
						pageNum: this.pageNum,
						pageSize: this.pageSize,
					}
				}
				else{
					queryAjax = this.getList
				}
			}
			
			queryAjax(params).then(({ data }) => {
				console.log('data: ', data);
				if (this.user && this.type != 9) {
					this.materialList.push(...data);
				} else {
					if (this.scrollLoading) {
						this.materialList.push(...data.result);
					} else {
						this.materialList = data.result;
					}
				}
				this.total = data.total || data.length;
				this.pages = data.pages || 1;
				
			}).finally(() => {
				this.loading = false;
				this.scrollLoading = false;
			});
		},
		// 免费付费素材列表查询
		getList() {
			console.log('getList: ',this.tab);
			return getMaterialList({
				pageNum: this.pageNum,
				pageSize: this.pageSize,
				fId: this.tab.format || '',
				cId: this.tab.category == 0? '': this.tab.category|| '',
				sort: this.tab.sort|| '',
				twoSort: this.tab.twoSort|| '',
				size: this.tab.size|| '',
				colorList: (this.tab.colorList || []).join(',')|| '',
				scale: this.tab.scale|| '',
				// lId: this.tab.label
			});
		},
		// 用户收藏素材列表查询
		getUserCollection() {
			return getUserCollectionMaterials({
				userId: this.user.id
			});
		},
		setMaterial(material) {
			if (!material.id) {
				return;
			}
			openWindow(`/#/material/detail/${material.id}`)
		}
	}
}
</script>

<style lang="scss" scoped>
.material-list {

    &-item {
        display: inline-block;
        margin-right: 28px;
        margin-top: 32px;
        width: 296px;
		&:nth-child(5n) {
			margin-right: 0;
		}
    }
	&__pagination {
        margin-top: 45px;
		padding-bottom: 30px;
        text-align: center;
    }
}
.loading {
    margin: 20px 0;
    text-align: center;
    font-size: 32px;
}
@include mq($small) {
    .material-list {
        padding-top: 15px;
        &-item {
            // margin-right: 10px;
            // margin-top: 10px;
			width: 272px;
			&:nth-child(4n) {
				margin-right: 28px;
			}
			&:nth-child(5n) {
				margin-right: 28px;
			}
        }
    }
}
</style>
